import { Autoplay, Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import { Link } from "react-router-dom"; // For internal links in React

const swiperOptions = {
    modules: [Autoplay, Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
        delay: 12000,
        disableOnInteraction: false,
    },
    loop: true,

    // Navigation
    navigation: {
        nextEl: '.h1n',
        prevEl: '.h1p',
    },

    // Pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
}

export default function Banner() {
    return (
        <>
  

            <section id="banner" className="banner-section style-four">
            <div className="banner-shape"><img src="../assets/images/main-slider/banner-shape-1.png" alt="" /></div>
            <div className="banner-shape2"><img src="assets/images/main-slider/banner-shape.png" alt="" /></div>
                <Swiper {...swiperOptions} className="banner-carousel theme_carousel owl-theme">
                    {/* Slide Item */}
                    {/* <SwiperSlide className="slide-item">
                        <div className="content-outer">
                            <div className="content-box">
                                <div className="inner">
                                    <h4 style={{color : 'white'}}>Empowering Independence, Enrich Lives</h4>
                                    <h1>Love & Care</h1>
                                    <div className="text">Are you on the lookout for a customized/quality care partner that is completely tailored to your needs and is fully committed to your well-being? <br /> ridiculus tellus.</div>
                                    <div className="link-box">
                                        <Link href="/#contact" className="btn-1 btn-large">Discover More <span></span></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="banner-feature-image d-none d-lg-block"><img src="assets/images/main-slider/banner-5.jpg" alt="" style={{ borderRadius: '15px' }}/></div>
                    </SwiperSlide> */}
<SwiperSlide
  className="slide-item"
  style={{
    backgroundImage: "url('assets/images/main-slider/banner-5.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderRadius: '15px',
  }}
>
  <div className="content-outer" style={{ padding: '0px 50px', backgroundColor: 'rgba(0, 0, 0, 0.4)', borderRadius: '15px' }}>
    <div className="content-box">
      <div className="inner">
        <h4 style={{ color: 'white' }}>Empowering Independence, Enrich Lives</h4>
        <h1 style={{ color: 'white' }}>Love & Care</h1>
        <div className="text" style={{ color: 'white',fontWeight : 800 }}>
          We are a staunch provider of exceptional disability support services for NDIS participants.
          <br /> From the thriving cosmopolitan of Western Australia
        </div>
        <div className="link-box">
          <Link to="/" className="btn-1 btn-large">Discover More <span></span></Link>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>
<SwiperSlide
  className="slide-item"
  style={{
    backgroundImage: "url('assets/images/main-slider/banner-55.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderRadius: '15px',
  }}
>
  <div className="content-outer" style={{ padding: '0px 50px', backgroundColor: 'rgba(0, 0, 0, 0.4)', borderRadius: '15px' }}>
    <div className="content-box">
      <div className="inner">
        <h4 style={{ color: 'white' }}>Empowering Independence, Enrich Lives</h4>
        <h1 style={{ color: 'white' }}>Care & Love</h1>
        <div className="text" style={{ color: 'white' ,fontWeight : 800 }}>
         We proudly deliver person-centred disability support services tailored to the unique needs of NDIS participants.
<br /> Rooted in the vibrant communities of Western Australia, we empower individuals to live with dignity and independence.
        </div>
        <div className="link-box">
          <Link to="/" className="btn-1 btn-large">Discover More <span></span></Link>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>
                   
                </Swiper>
            </section>
        </>
    )
}
